<template>
   <div class="main" v-if="showPage">
       <div class="main-propval">
            <div class="main-choose">
                <ul>
                    <li v-for="(item,index) in projectDict.bg_project_category" :key="index" @click="togpHome(index)">
                        <span>{{ item.dict_label }}</span><a-icon type="right" />
                    </li>
                </ul>    
            </div>
            <div class="main-carousel">
                    <a-carousel autoplay arrows>
                        <div
                        slot="prevArrow"
                        slot-scope="props"
                        class="custom-slick-arrow"
                        style="left: 10px;zIndex: 1"
                        >
                        <a-icon type="left-circle" />
                        </div>
                        <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
                        <a-icon type="right-circle" />
                        </div>
                       <img v-for="(item,index) in imglist" :key="index" :src="item" height="374">
                    </a-carousel>
            </div>
            <div class="main-news">
                    <div class="title"><span>公告</span><span style="cursor:pointer;" @click="$router.push('/notice')">查看更多</span></div>
                    <ul>
                        <li v-for="(item,index) in noticelist" :key="index" @click="$router.push({ path:'/details',query:{ id:item.id }})">
                         <span>
                            <a-tooltip>
                                <template slot="title">
                                 {{ item.contentTitle }}
                                </template>
                                 {{ item.contentTitle }}
                            </a-tooltip>
                         </span>
                        <a-icon type="right" /></li>
                    </ul>    
            </div>
       </div>
       <div class="firstTitle" v-if="firstRecommend.length>0" style="background:#ffff"><p>热门推荐</p></div>
       <div class="firstRecommend" style="background:#fff;padding:20px;">
          <div v-for="(item,index) in firstRecommend" v-if="index<4">
               <img :src="item.pictureUrl[0]" @click="$router.push({ path:'/quetaDetail',query:{ id:item.id } })">
          </div>
       </div>
       <container></container>
       <recommendation></recommendation>
       <div class="goodsHallTitle"><p>合作伙伴</p></div>
       <div class="coperat-content">
          <div v-for="(item,index) in coperatList">
             <img :src="item.titleImage">
          </div>
       </div>
   </div>    
</template>

<script>
import container from '@/views/main/components/container' 
import recommendation from '@/views/main/components/recommendation'
export default {
    components:{
        container,
        recommendation
    },
    data(){
        return{
             projectDict:'',
             imglist:[],
             noticelist:[],
             showPage:false,
             firstRecommend:[],
             coperatList:[]
        }
    },
    created(){
       //获取字典
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                }else{
                     this.$message.info(res.msg)
                }
        })
        this.getPics();
        this.getNotice();
          //获取1级推荐
        this.getProjectFirstRecommend();
        this.getcoperatList();
    },
    mounted(){
        this.$parent.current = '1';
    },
    methods:{
        getcoperatList(){
            this.$https.get('/portal/index/getContentById/18').then(res=>{
                  this.coperatList = res;
            })
        },
        getProjectFirstRecommend(){
            this.$https.get('/portal/index/getProjectFirstRecommend').then(res=>{
                if(res.code == 200){
                    res.rows.forEach(item=>{
                        item.pictureUrl = item.pictureUrl.split(',');
                    })
                    this.firstRecommend = res.rows;
                }
            })
        },
        getPics(){
             this.$https.get('/portal/index/getContentById/16').then(res=>{
                 res.forEach(item => {
                    this.imglist.push(item.titleImage);
                    this.showPage = true;
                 });
             })
        },
        getNotice(){
            this.$https.get('/portal/index/getNotice').then(res=>{
                this.noticelist = res;
            })
        },
        togpHome(index){
            this.$router.push({
                path:'/quetaHome',
                query:{
                    index:index
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.main{
    width: 1300px;
    margin:0 auto;
    .firstRecommend{
        display: flex;
        // justify-content: space-between;
        // margin-top:20px;
        div{
            width: 300px;
            height: 200px;
            margin-right:8px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            img{
                width: 300px;
                height: 200px;
                cursor: pointer;
            }
            &:hover{
                transform:scale(1.1,1.1);
                transition:All 0.4s ease-in-out;
                -webkit-transition:All 0.4s ease-in-out;
                -moz-transition:All 0.4s ease-in-out;
                -o-transition:All 0.4s ease-in-out;
            }
        }
    }
    .main-propval{
            display: flex;
            position: relative;
            height: 374px;
            overflow: hidden;
            .main-choose-list{
                display: none;
                position: absolute;
                width: 850px;
                height: 368px;
                left: 200px;
                top:0;
                background-color: #fff;
                z-index: 100;
                border-left:1px solid #eeeeee;
                border-right:1px solid #eeeeee;
            }
            .main-choose{
                width: 200px;
                background: #fff;
                ul{
                    li{
                        height: 60px;
                        line-height: 60px;
                        padding:0 10px;
                        border-bottom: 1px solid #eeeeee;
                        display: flex;
                        justify-content: space-between;
                        cursor: pointer;
                        &:hover{
                            background:#eeeeee;
                        }
                        i{
                            line-height: 60px;
                        }
                    }
                }
            }
            .main-carousel{
                width: 850px;
            }
            .main-news{
                width: 250px;
                background: #fff;
                .title{
                    display: flex;
                    padding: 0 10px;
                    justify-content: space-between;
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #eeeeee;
                }
                ul{
                    li{
                        height: 40px;
                        line-height: 40px;
                        padding:0 10px;
                        border-bottom: 1px solid #eeeeee;
                        display: flex;
                        justify-content: space-between;
                        cursor:pointer;
                        &:hover{
                            background: #eeeeee;
                        }
                        span{
                            white-space:nowrap; 
                            overflow:hidden; 
                            text-overflow:ellipsis; 
                            white-space:nowrap; 
                        }
                        i{
                            line-height: 40px;
                        }
                    }
                }
            }
    }
    .ant-carousel  .slick-slide {
    text-align: center;
    height: 160px;
    line-height: 160px;
    background: #364d79;
    overflow: hidden;
  }
  
  .ant-carousel  .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
  }
  .ant-carousel  .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel  .custom-slick-arrow:hover {
    opacity: 0.5;
  }
  
  .ant-carousel  .slick-slide h3 {
    color: #fff;
  }
}
.goodsHallTitle{
        height: 80px;
        line-height: 80px;
        text-align: center;
        position: relative;
        p{
            font-size: 20px;
            color: #666;
            margin-bottom:0;
        }
    }
.firstTitle{
        background: #fff;
        height: 60px;
        line-height: 60px;
        margin-top:20px;
        text-align: center;
        position: relative;
        p{
            font-size: 20px;
            color: #666;
            margin-bottom:0;
        }
}    
.coperat-content{
    display: flex;
    flex-wrap:wrap;
     background: #fff;
    div{
        width: 25%;
        height: auto;
        img{
            padding: 20px;
            width: 80%;
            height: auto;
        }
    }
}    
</style>